import React from 'react';

import { AddExistingResourcesForm } from '@/console/features/groups/components/add-existing-resources/add-existing-resources-form';
import {
  TAddExistingResourcesInputSchema,
  TAddExistingResourcesProps,
} from '@/console/features/groups/components/add-existing-resources/add-existing-resources.types';
import { withTypename } from '@/console/features/groups/components/add-existing-resources/add-existing-resources.utils';
import { addExistingResourcesInputSchema } from '@/console/features/groups/components/add-existing-resources/add-existing-resources.validation';
import { Form } from '@/shared/components/ui/form/form';
import { TSubmittedData } from '@/shared/components/ui/form/form.types';
import { useGroupResourceActions } from '@/shared/features/groups/hooks/use-group-resource-actions/use-group-resource-actions';

export const AddExistingResources: React.FC<TAddExistingResourcesProps> = ({
  typename,
  groupId,
  handleClose,
  ...rest
}) => {
  const { moveResourcesToGroup } = useGroupResourceActions();

  const onSubmit = async (
    data: TSubmittedData<TAddExistingResourcesInputSchema>,
  ) => {
    const resources = data.data.resources.map((resource) =>
      withTypename(resource, typename),
    );

    await moveResourcesToGroup(resources, groupId, undefined, handleClose);
  };

  return (
    <Form<TAddExistingResourcesInputSchema>
      onSubmit={onSubmit}
      schema={addExistingResourcesInputSchema}
    >
      {() => (
        <AddExistingResourcesForm
          {...rest}
          typename={typename}
          groupId={groupId}
          onClose={handleClose}
        />
      )}
    </Form>
  );
};
